import request         from '@/request/index.js';
import responseHandler from '@/utils/responseHandler.js';

const queryUserVirusTrip = () => {
  return request.ticket( {
    url       : '/gateway/gtgj/act2',
    sidFields : [ 'uid', 'pid' ],
    auth      : 'yes',

    data : {
      pid : '335272'
    }
  } ).then( responseHandler.resBdData );
};

export default queryUserVirusTrip;



// WEBPACK FOOTER //
// ./src/projects/virusTrip/service/query-user-virus-trip.js